







import { Vue, Component, Prop } from 'vue-property-decorator';
import GTopicSubject from '@/components/GTopicSubject.vue';

@Component({
  name: 'GTextView',
  components: { GTopicSubject },
  computed: {},
  methods: {},
})
export default class GTextView extends Vue {
  @Prop() text: string;
  mounted() {}

  get htmlText(): string {
    return this.text.replace(/\n/g, '<br />');
  }
}
